module.exports = __webpack_public_path__ + "img/where-are-we.78a5ffe1.svg";